import { Td } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useGetPortalMyBidsQuery } from "../../../../autogen/bff-api";
import { useDisplayDate } from "../../../../common/formatting/useDisplayDate";
import { urls } from "../../../../urls";
import { BidV2StatusTag } from "../../sourcing-event/BidV2StatusTag";
import { HomePanel } from "./HomePanel";
import { MutedCell, PanelRow, PanelTable, TitleCell } from "./PanelTable";

const DISPLAY_LIMIT = 6;

export const MyBidsPanel = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const displayDate = useDisplayDate();

  const { data, isLoading, isError } = useGetPortalMyBidsQuery({});
  const bids = (data?.bids ?? []).slice(0, DISPLAY_LIMIT);

  return (
    <HomePanel titleKey="My bids" seeAllTo={urls.v2.supplier.bids} isLoading={isLoading} isError={isError} isEmpty={bids.length === 0} emptyKey="No offers yet">
      <PanelTable headers={[t("Title"), t("Status"), t("Deadline")]}>
        {bids.map((bid) => (
          <PanelRow key={bid.event.id} onClick={() => navigate(urls.v2.supplier.procurement.go(bid.eventId))}>
            <TitleCell title={bid.event.title || t("Untitled")} />
            <Td><BidV2StatusTag status={bid.status} size="sm" /></Td>
            <MutedCell>
              {bid.event.bidSubmissionDeadline ? displayDate(bid.event.bidSubmissionDeadline) : "—"}
            </MutedCell>
          </PanelRow>
        ))}
      </PanelTable>
    </HomePanel>
  );
};
